import { memo } from "react";
import { SearchOutlined } from "@ant-design/icons";

import SearchBarComponent from "components/SearchBar";
import { TextInput, Filter } from "components/common/Form";

const ACTIVE_OPTIONS = [
  { label: "Đang hoạt động", value: true },
  { label: "Không hoạt động", value: false },
];

const SearchBar = () => (
  <SearchBarComponent
    filterFields={["keyword", "isActive"]}
    isOnChangeSearch
  >
    <>
      <TextInput
        size="middle"
        prefix={<SearchOutlined />}
        name="keyword"
        allowClear={false}
      />
      <Filter
        styles={{ marginLeft: 8 }}
        name="isActive"
        width="20px"
        options={ACTIVE_OPTIONS}
        popConfirmClassName="consulate-role-popconfirm"
      />
    </>
  </SearchBarComponent>
);

export default memo(SearchBar);
